import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import './SocialModal.css';

const SocialModal = ({ open, onClose, platform, handle }) => {
  const getUrl = () => {
    switch(platform) {
      case 'instagram':
        return `https://instagram.com/${handle}`;
      case 'youtube':
        return `https://youtube.com/@${handle}`;
      case 'tiktok':
        return `https://tiktok.com/@${handle}`;
      case 'x':
        return `https://x.com/${handle}`;
      case 'facebook':
        return `https://facebook.com/${handle}`;
      case 'pinterest':
        return `https://pinterest.com/${handle}`;
      case 'podcast':
        return handle; // Assume full URL
      default:
        return '#';
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="social-modal-content">
        <DialogHeader>
          <DialogTitle className="social-modal-title">
            {platform.charAt(0).toUpperCase() + platform.slice(1)} Profile
          </DialogTitle>
        </DialogHeader>
        <div className="social-modal-body">
          <p className="social-handle">@{handle}</p>
          <a 
            href={getUrl()} 
            target="_blank" 
            rel="noopener noreferrer"
            className="visit-profile-btn"
          >
            Visit Profile
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SocialModal;